<template>
  <div class="t-panel">
    <CollapsedPanel
      :key="collapsedKey"
      opened
      :collapsible="collapsible"
      class="t-panel__collapsed-tracks"
      ><template #title>
        <p class="t-panel__collapsed-track">Трек</p>
        <p class="t-panel__collapsed-title">{{ title }}</p>
      </template>
      <div v-if="!short" class="t-panel__collapsed-body">
        <div v-if="junior" class="t-panel__collapsed-body-item">
          <div class="t-panel__collapsed-body-header">
            <BaseIcon
              glyph="logo"
              width="20px"
              class="mr-s t-panel__collapsed-body-logo"
              :class="{
                active: request && request.event && request.event.id === junior,
              }"
            />
            <div>
              <p class="t-panel__collapsed-body-text">
                Младшая лига
                <span class="t-panel__collapsed-body-text-gray"
                  >(кружки для школьников 1-4&nbsp;класса)</span
                >.
              </p>
              <div
                v-if="request && request.event && request.event.id === junior"
                class="t-panel__collapsed-body-complete"
              >
                <p class="mb-s">
                  Вы&nbsp;уже подали заявку на&nbsp;текущий трек &laquo;{{
                    title
                  }}&raquo;&nbsp;/ &laquo;Младшая лига&raquo;.
                </p>
                <div
                  v-if="
                    status &&
                    request &&
                    request.event &&
                    request.event.id === junior
                  "
                  class="t-panel__status status-invisible"
                  :class="status.class"
                >
                  <BaseIcon :glyph="status.icon" width="18px" />
                  {{ status.label }}
                </div>
                <a
                  :href="requestLink"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="link-base link_last"
                  >Перейти к заявке&nbsp;<BaseIcon
                    glyph="chevron-right"
                    class="invisible"
                /></a>
              </div>
            </div>
          </div>
          <component
            :is="tag"
            v-if="!request"
            href="#participate"
            class="link-base t-panel__collapsed-body-register"
            @click="handleRegister(junior)"
            >Регистрация&nbsp;<BaseIcon glyph="chevron-right"
          /></component>
          <div
            v-else-if="
              status && request && request.event && request.event.id === junior
            "
            class="t-panel__status"
            :class="status.class"
          >
            <BaseIcon :glyph="status.icon" width="18px" />
            {{ status.label }}
          </div>
        </div>

        <div v-if="middle" class="t-panel__collapsed-body-item">
          <div class="t-panel__collapsed-body-header">
            <BaseIcon
              glyph="logo"
              width="20px"
              class="mr-s t-panel__collapsed-body-logo"
              :class="{
                active: request && request.event && request.event.id === middle,
              }"
            />
            <div>
              <p class="t-panel__collapsed-body-text">
                Средняя лига
                <span class="t-panel__collapsed-body-text-gray"
                  >(кружки для школьников 5-8&nbsp;классов)</span
                >.
              </p>
              <div
                v-if="request && request.event && request.event.id === middle"
                class="t-panel__collapsed-body-complete"
              >
                <p class="mb-s">
                  Вы&nbsp;уже подали заявку на&nbsp;текущий трек &laquo;{{
                    title
                  }}&raquo;&nbsp;/ &laquo;Средняя лига&raquo;.
                </p>
                <div
                  v-if="
                    status &&
                    request &&
                    request.event &&
                    request.event.id === middle
                  "
                  class="t-panel__status status-invisible"
                  :class="status.class"
                >
                  <BaseIcon :glyph="status.icon" width="18px" />
                  {{ status.label }}
                </div>
                <a
                  :href="requestLink"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="link-base link_last"
                  >Перейти к заявке&nbsp;<BaseIcon
                    glyph="chevron-right"
                    class="invisible"
                /></a>
              </div>
            </div>
          </div>
          <component
            :is="tag"
            v-if="!request"
            href="#participate"
            class="link-base t-panel__collapsed-body-register"
            @click="handleRegister(middle)"
            >Регистрация&nbsp;<BaseIcon glyph="chevron-right"
          /></component>
          <div
            v-else-if="
              status && request && request.event && request.event.id === middle
            "
            class="t-panel__status"
            :class="status.class"
          >
            <BaseIcon :glyph="status.icon" width="18px" />
            {{ status.label }}
          </div>
        </div>

        <div v-if="senior" class="t-panel__collapsed-body-item">
          <div class="t-panel__collapsed-body-header">
            <BaseIcon
              glyph="logo"
              width="20px"
              class="mr-s t-panel__collapsed-body-logo"
              :class="{
                active: request && request.event && request.event.id === senior,
              }"
            />
            <div>
              <p class="t-panel__collapsed-body-text">
                Старшая лига
                <span class="t-panel__collapsed-body-text-gray"
                  >(кружки для школьников 9-11&nbsp;классов)</span
                >.
              </p>
              <div
                v-if="request && request.event && request.event.id === senior"
                class="t-panel__collapsed-body-complete"
              >
                <p class="mb-s">
                  Вы&nbsp;уже подали заявку на&nbsp;текущий трек &laquo;{{
                    title
                  }}&raquo;&nbsp;/ &laquo;Старшая лига&raquo;.
                </p>
                <div
                  v-if="
                    status &&
                    request &&
                    request.event &&
                    request.event.id === senior
                  "
                  class="t-panel__status status-invisible"
                  :class="status.class"
                >
                  <BaseIcon :glyph="status.icon" width="18px" />
                  {{ status.label }}
                </div>
                <a
                  :href="requestLink"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="link-base link_last"
                  >Перейти к заявке&nbsp;<BaseIcon
                    glyph="chevron-right"
                    class="invisible"
                /></a>
              </div>
            </div>
          </div>
          <component
            :is="tag"
            v-if="!request"
            href="#participate"
            class="link-base t-panel__collapsed-body-register"
            @click="handleRegister(senior)"
            >Регистрация&nbsp;<BaseIcon glyph="chevron-right"
          /></component>
          <div
            v-else-if="
              status && request && request.event && request.event.id === senior
            "
            class="t-panel__status"
            :class="status.class"
          >
            <BaseIcon :glyph="status.icon" width="18px" />
            {{ status.label }}
          </div>
        </div>

        <div v-if="interage" class="t-panel__collapsed-body-item">
          <div class="t-panel__collapsed-body-header">
            <BaseIcon
              glyph="logo"
              width="20px"
              class="mr-s t-panel__collapsed-body-logo"
              :class="{
                active:
                  request && request.event && request.event.id === interage,
              }"
            />
            <div>
              <p class="t-panel__collapsed-body-text">
                Межвозрастная лига
                <span class="t-panel__collapsed-body-text-gray"
                  >(смешанные по&nbsp;возрастам кружки)</span
                >.
              </p>
              <div
                v-if="request && request.event && request.event.id === interage"
                class="t-panel__collapsed-body-complete"
              >
                <p class="mb-s">
                  Вы&nbsp;уже подали заявку на&nbsp;текущий трек &laquo;{{
                    title
                  }}&raquo;&nbsp;/ &laquo;Межвозрастная лига&raquo;.
                </p>
                <div
                  v-if="
                    status &&
                    request &&
                    request.event &&
                    request.event.id === interage
                  "
                  class="t-panel__status status-invisible"
                  :class="status.class"
                >
                  <BaseIcon :glyph="status.icon" width="18px" />
                  {{ status.label }}
                </div>
                <a
                  :href="requestLink"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="link-base link_last"
                  >Перейти к заявке&nbsp;<BaseIcon
                    glyph="chevron-right"
                    class="invisible"
                /></a>
              </div>
            </div>
          </div>
          <component
            :is="tag"
            v-if="!request"
            href="#participate"
            class="link-base t-panel__collapsed-body-register"
            @click="handleRegister(interage)"
          >
            Регистрация&nbsp;<BaseIcon glyph="chevron-right" />
          </component>
          <div
            v-else-if="
              status &&
              request &&
              request.event &&
              request.event.id === interage
            "
            class="t-panel__status"
            :class="status.class"
          >
            <BaseIcon :glyph="status.icon" width="18px" />
            {{ status.label }}
          </div>
        </div>
      </div>
      <div v-else class="tracks__collapsed-body">
        <p
          v-if="request && request.event && request.event.id === development"
          class="mb-s"
        >
          Вы&nbsp;уже подали заявку на&nbsp;текущий трек &laquo;{{
            title
          }}&raquo;
        </p>
        <p
          v-else-if="
            request && request.event && request.event.id !== development
          "
          class="mb-s"
        >
          Вы&nbsp;уже подали заявку на один из треков
        </p>
        <div
          v-if="
            status &&
            request &&
            request.event &&
            request.event.id === development
          "
          class="t-panel__status permanent"
          :class="status.class"
        >
          <BaseIcon :glyph="status.icon" width="18px" />
          {{ status.label }}
        </div>
        <component
          :is="tag"
          v-if="!request"
          href="#participate"
          class="link-base link_last t-panel__collapsed-body-register"
          @click="handleRegister(development)"
        >
          Регистрация&nbsp;<BaseIcon glyph="chevron-right" />
        </component>
      </div>
    </CollapsedPanel>
  </div>
</template>

<script>
import CollapsedPanel from "@/components/CollapsedPanel";
import {
  REQUEST_STATUS_AWAIT,
  REQUEST_STATUS_CANCELED,
  REQUEST_STATUS_CONFIRMED,
} from "@/constants";
export default {
  name: "TrackPanel",
  components: { CollapsedPanel },
  props: {
    title: {
      type: String,
      default: "",
    },
    short: {
      type: Boolean,
      default: false,
    },
    junior: Number,
    middle: Number,
    senior: Number,
    interage: Number,
    development: Number,
    request: Object,
    isOrganizations: {
      type: Boolean,
      default: false,
    },
    collapsible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      collapsedKey: 1,
    };
  },
  watch: {
    request: {
      deep: true,
      handler(val) {
        if (val?.id) {
          this.collapsedKey++;
        }
      },
    },
  },
  computed: {
    tag() {
      return this.isOrganizations &&
        this.selectedOrganization &&
        this.selectedPlatform
        ? "button"
        : "a";
    },
    selectedOrganization() {
      return this.$store.state.requestPreparing.selectedOrganization;
    },
    selectedPlatform() {
      return this.$store.state.requestPreparing.selectedPlatform;
    },
    requestLink() {
      if (!this.request) return;
      return `${process.env.VUE_APP_TALENT_HOST}/events/requests/${this.request.id}`;
    },
    status() {
      const { request } = this;
      switch (request?.status) {
        case REQUEST_STATUS_CANCELED:
          return {
            class: "color-error",
            icon: "dell",
            label: "Заявка отклонена",
          };
        case REQUEST_STATUS_CONFIRMED:
          return {
            class: "color-success",
            icon: "done",
            label: "Подтверждено",
          };
        case REQUEST_STATUS_AWAIT:
          return {
            class: "color-info",
            icon: "time",
            label: "На модерации",
          };
        default:
          return null;
      }
    },
  },
  methods: {
    handleRegister(id) {
      if (
        !this.isOrganizations ||
        !this.selectedOrganization ||
        !this.selectedPlatform
      )
        return;
      this.$emit("handleRegister", id);
    },
  },
};
</script>

<style lang="less" scoped>
.t-panel {
  &__collapsed-tracks {
    box-shadow: 0 2px 6px rgba(15, 82, 97, 0.2);
    & + & {
      margin-top: @margin-s;
    }
  }
  &__collapsed-track {
    font-size: @font-size-s;
    line-height: @line-height-s;
    color: @primary-color;
    font-weight: bold;
  }

  &__collapsed-title {
    font-size: @font-size-l;
    line-height: @line-height-l;
    font-weight: bold;
  }

  &__collapsed-body {
    &-item {
      padding: 10px 20px;
      display: flex;
      align-items: flex-start;
      background-color: #fff;
      border: 1px solid @blue-color;
      border-radius: @border-radius-xs;
      justify-content: space-between;
      flex-wrap: nowrap;

      & + & {
        margin-top: @margin-s;
      }
    }
    &-header {
      display: flex;
      align-items: flex-start;
      margin-right: @margin-s;
    }

    &-logo {
      color: @primary-color;
      flex-shrink: 0;

      &.active {
        color: @base-color;
      }
    }

    &-text-gray {
      color: @dark-gray-color;
    }

    &-complete {
      font-size: @font-size-s;
      line-height: @line-height-s;
      margin-top: @margin-s;
    }

    &-register {
      background-color: transparent;
      outline: none;
      border: 0;
      box-shadow: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      font-family: inherit;
      padding: 0;
      margin: 0;
      font-size: inherit;
      line-height: inherit;
    }
  }

  .link-base {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
  }

  &__status {
    font-size: 13px;
    line-height: 20px;
    display: inline-flex;
    align-items: center;
    width: max-content;
    flex-shrink: 0;

    &.status-invisible {
      display: none;
    }

    .base-icon {
      margin-right: 10px;
    }
    &.color-info {
      color: @info-color;
    }
    &.color-error {
      color: @error-color;
    }
    &.color-success {
      color: @success-color;
    }
  }

  @media (max-width: @screen-xs) {
    &__collapsed-title {
      font-size: @base-font-size;
      line-height: @base-line-height;
    }

    &__collapsed-body {
      font-size: @font-size-s;
      line-height: @line-height-s;
    }
    .invisible {
      display: none;
    }
  }

  @media (max-width: @screen-xs-max) {
    &__collapsed-body {
      &-item {
        flex-direction: column;
        padding: 10px;
      }
    }
    .link-base:not(.link_last) {
      margin-left: @margin-l;
      margin-top: @margin-s;
    }
    &__status {
      &:not(.permanent) {
        display: none;
      }
      &.status-invisible {
        display: inline-flex;
      }
    }
  }
}
</style>
